import { ReactElement } from "react";

import { SearchWorkflowTasksResponse } from "../../../../../service/query";
import { Column, CursorDataGrid, FlyoutPanel, Row } from "../../../../../widget";
import { useTeamTasksPanel } from "./useTeamTasksPanel";

interface TeamTasksPanelProps {
  show: boolean;
  onClose: () => void;
  setSelectedPanelTask: (task: SearchWorkflowTasksResponse["results"][0] | undefined) => void;
  setShowWorkflowTaskPanel: (show: boolean) => void;
  refreshTasks: boolean;
}

export const TeamTasksPanel = ({
  show,
  onClose,
  setSelectedPanelTask,
  setShowWorkflowTaskPanel,
  refreshTasks,
}: TeamTasksPanelProps): JSX.Element => {
  const { columns, defaultSortingCriteria, dataIsLoading, onChange } = useTeamTasksPanel(
    setSelectedPanelTask,
    setShowWorkflowTaskPanel
  );

  const content = (): ReactElement => (
    <div className="TeamTasksPanelContent">
      <div className="TeamTasksTable">
        <Row>
          <Column span={12}>
            <CursorDataGrid
              columns={columns}
              clientSide={false}
              filterable
              onChange={onChange}
              sortable
              data={[]}
              refresh={refreshTasks}
              dataIsLoading={dataIsLoading}
              defaultSortingCriteria={defaultSortingCriteria}
              noDataMessage="No tasks to display"
            />
          </Column>
        </Row>
      </div>
    </div>
  );

  return (
    <FlyoutPanel
      show={show}
      onClose={onClose}
      size="Large"
      header="Team tasks"
      contentChildren={content()}
      buttonsChildren={undefined}
    />
  );
};
